import {getField, updateField} from "vuex-map-fields"
import {Api} from '@/plugins/axios'

let campaign = {
    adSets : [],
    budget_amount : 0,
    budget_type : 'daily_budget',
    end_date : '',
    start_date : '',
    name : '',
    objective : 'LINK_CLICKS',
    billing_exempt : 'no',
    billing_profile_id : null
}

let blank_adset = {
    ads : [],
    properties : [],
    name : '',
    target : {
        type : null,
        place : null,
        radius : 15
    }
}

let blank_ad = {
    name : '',
    creative : {}
}

export const state = () => ({
    campaign: {
        adSets : [],
        budget_amount : 0,
        budget_type : 'daily_budget',
        end_date : '',
        start_date : '',
        name : '',
        objective : 'LINK_CLICKS',
        billing_exempt : 'no',
        billing_profile_id : null,
        page : null,
        adAccount : null,
        facebookPage : {},
    },
    blank_adset : blank_adset,
    blank_ad : blank_ad,
    creatorComponent : null,
    smartLists : [],
    adAccounts : [],
    pages : [],
    facebookToken : {},
    progress : {
        text : '',
        error : '',
        perc : 0
    },
    uuid : null,
    wizardStep: 1,
})


export const getters = {
    getField,
}

export const mutations = {
    updateField,
    resetCampaign(state){
        state.campaign = Object.assign({}, campaign)
        state.creatorComponent = null
        state.wizardStep = 1
    },

    resetSmartLists(state){
        state.smartLists = []
    },

    resetAdAccounts(state){
        state.adAccounts = []

    },

    async getSmartLists(state){
        if ( state.smartLists.length > 0 ) return

        let { data : { smartLists } } = await Api.get('/api/v1/smart-lists', { params : { facebook_adaccount_id : state.campaign.facebook_adaccount_id } })
        state.smartLists = smartLists
    },

    async getAdAccounts(state){
        if ( state.adAccounts.length > 0 ) return

        let { data : { adAccounts } } = await Api.get('/api/v1/facebook/get-ad-accounts')
        state.adAccounts = adAccounts

        if ( adAccounts.length === 1 ){
            state.campaign.adAccount = adAccounts[0]
        }
    }
}
